import { render, staticRenderFns } from "./Saude.vue?vue&type=template&id=efe701b4&scoped=true"
import script from "./Saude.vue?vue&type=script&lang=js"
export * from "./Saude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe701b4",
  null
  
)

export default component.exports